export default "__VITE_ASSET__dC6_6T0s__"